// @flow
import SMRestClient from 'lib/SMRestClient';

class SMPointCodeResource {
  static applyPointCode(requestBody: Object, userId: String, completion: Function) {
    const url = `/1/users/${userId}/applied_point_codes.json`;
    const apiClient = new SMRestClient();
    apiClient.post(url, requestBody).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        completion(null, error, xhr);
      });
  }
}
export default SMPointCodeResource;



// WEBPACK FOOTER //
// ./app/javascript/resources/SMPointCodeResource.js